import {
  MDBContainer, MDBRow, MDBCol, MDBBtn,
} from 'mdbreact';
import DatePicker from 'react-date-picker';
import React, { useContext, useState, useRef } from 'react';
import { UserContext } from '../UserContext';

function AddEvent() {
  const baseURL = process.env.REACT_APP_API_BASEURL;
  const userContext = useContext(UserContext);

  const newEventNameRef = useRef(null);
  const newEventCategoryRef = useRef(null);
  const newEventMaxHoursRef = useRef(null);
  const newEventMinHoursRef = useRef(null);
  const newEventCommentsRef = useRef(null);
  const [newEventDateVal, onNewEventDateValChange] = useState(new Date());

  const createNewEvent = (event) => {
    event.preventDefault();

    if (userContext.name === '') {
      alert('Not Authorized');
      return;
    }

    fetch(`${baseURL}/api/activity`, {
      method: 'POST',
      body: JSON.stringify({
        name: newEventNameRef.current.value,
        category: newEventCategoryRef.current.value,
        min_suggested_hours: newEventMinHoursRef.current.value,
        max_suggested_hours: newEventMaxHoursRef.current.value,
        comments: newEventCommentsRef.current.value,
        event_date: `${newEventDateVal.getFullYear()}-${
          newEventDateVal.getMonth() + 1
        }-${newEventDateVal.getDate()}`,
      }),
      headers: {
        Authorization: `${userContext.tokenID}`,
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          alert('Activity Created Successfully.');
          window.location.reload();
        } else {
          const responseData = res.json();
          responseData.then((response) => {
            alert(response.error);
          });
        }
      })
      .catch((err) => {
        alert('POST Request Failed, Please try again later');
        console.log(err);
      });
  };

  return (
    <>
      {/* 2.5 rem is to keep the bottom clear of the navbar */}
      <MDBContainer style={{ marginBottom: '2.5rem' }} fluid>
        <MDBRow center>
          <MDBCol md="6">
            <form onSubmit={createNewEvent}>
              <p className="h2 text-center mb-4">Add an Event</p>
              <label htmlFor="eventName" className="black-text">
                Event Name
              </label>
              <input
                type="text"
                id="eventName"
                className="form-control"
                ref={newEventNameRef}
                required
              />

              <br />
              <label htmlFor="category" className="balck-text">
                Category
              </label>
              <div>
                <select
                  className="browser-default custom-select"
                  id="category"
                  ref={newEventCategoryRef}
                >
                  <option value="1">Category 1</option>
                  <option value="2">Category 2</option>
                  <option value="3">Category 3</option>
                  <option value="4">Category 4</option>
                  <option value="5">Category 5</option>
                  <option value="6">Category 6</option>
                </select>
              </div>

              <br />
              <label htmlFor="date" className="black-text">
                Event Date
              </label>
              <div>
                <DatePicker
                  onChange={onNewEventDateValChange}
                  value={newEventDateVal}
                  id="date"
                />
              </div>

              <br />
              <label htmlFor="minhours" className="black-text">
                Minimum Suggested Hours
              </label>
              <input
                type="number"
                id="minhours"
                className="form-control"
                ref={newEventMinHoursRef}
                required
              />

              <br />
              <label htmlFor="maxhours" className="black-text">
                Maximum Suggested Hours
              </label>
              <input
                type="number"
                id="maxhours"
                className="form-control"
                ref={newEventMaxHoursRef}
                required
              />
              <br />
              <label htmlFor="comments" className="black-text">
                Comments
              </label>
              <input
                type="text"
                id="comments"
                className="form-control"
                ref={newEventCommentsRef}
              />

              <br />
              <div className="text-center mt-4">
                <MDBBtn color="primary" type="submit">
                  Update
                </MDBBtn>
              </div>
            </form>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </>
  );
}

export default AddEvent;
